import { render, staticRenderFns } from "./SampleResultChemical.vue?vue&type=template&id=6ea11d3a&scoped=true"
import script from "./SampleResultChemical.vue?vue&type=script&lang=js"
export * from "./SampleResultChemical.vue?vue&type=script&lang=js"
import style0 from "./SampleResultChemical.vue?vue&type=style&index=0&id=6ea11d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea11d3a",
  null
  
)

export default component.exports